<script lang="ts" setup>
import { Field, useField, ErrorMessage } from 'vee-validate';
import { ref } from 'vue';

const { value } = useField<string>('memberNumber');

const props = defineProps<{
  errors?: string | string[];
}>();

const focused = ref(false);

</script>

<template>
  <div class="form-row">
    <div class="col">
      <div
        class="field"
        :class="{
          changed: value,
          'is-focused': focused,
          'is-invalid': errors,
        }"
      >
        <Field
          type="text"
          name="memberNumber"
          id="memberNumber"
          :class="{ 'is-invalid': errors }"
          maxlength="16"
          @focus="focused = true"
          @blur="focused = false"
          @keyup="
            value =
              '308147' +
              value.replace(/[^\d]*/g, '').replace(/308147|30814/, '')
          "
        />
        <label for="memberNumber">* AerClub Membership Number</label>
        <div class="invalid-feedback">
          <ErrorMessage name="memberNumber" />
        </div>
      </div>
    </div>
  </div>
</template>
